// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5198f1ff","488":"69973380","611":"5f760805"}[chunkId] + ".chunk.js";
};